<template>
  <ul class="nav nav-mobile-menu">
    <slot name="mobile-menu-itens" />
  </ul>
</template>
<script>
export default {
  name: "mobile-menu"
};
</script>
<style>
</style>
